import * as React from "react"
import type { SVGProps } from "react"
const SvgLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7 17.14a4.8 4.8 0 0 1-3.54-1.46Q2 14.22 2 12.14c0-2.08.49-2.56 1.46-3.53A4.8 4.8 0 0 1 7 7.14h3a.97.97 0 0 1 1 1q0 .43-.29.71a1 1 0 0 1-.71.3H7q-1.25 0-2.12.87A3 3 0 0 0 4 12.14q0 1.25.88 2.13a3 3 0 0 0 2.12.87h3a.97.97 0 0 1 1 1q0 .43-.29.72a1 1 0 0 1-.71.28zm2-4a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h6a.97.97 0 0 1 1 1q0 .43-.29.72a1 1 0 0 1-.71.28zm5 4a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h3q1.24 0 2.13-.87a3 3 0 0 0 .87-2.13q0-1.25-.87-2.12A3 3 0 0 0 17 9.14h-3a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h3q2.07 0 3.54 1.47Q22 10.07 22 12.14c0 2.07-.49 2.57-1.46 3.54A4.8 4.8 0 0 1 17 17.14z" />
  </svg>
)
export default SvgLink
